// file: asyncPermissionFetch.js
import { API_ENDPOINTS } from "../../../constants/endPoints";
import axios from "../../../services/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchClient = createAsyncThunk(
  "commonModule/fetchClient",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_all_client_list);
      if (data.status) {
        return data?.data?.docs;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      ); // Return the error message
    }
  }
);

export const fetchCategories = createAsyncThunk(
  "commonModule/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_all_category_list);
      if (data.status) {
        return data?.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      ); // Return the error message
    }
  }
);

export const fetchAgents = createAsyncThunk(
  "commonModule/fetchAgents",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_all_agent_list);
      if (data.status) {
        return data?.data?.docs;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

export const fetchType = createAsyncThunk(
  "commonModule/fetchType",
  async ({ type, key }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_type, {
        params: { type },
      });

      if (data.status) {
        return { key, data: data?.data }; // Return key and data
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);

export const fetchEmployee = createAsyncThunk(
  "commonModule/fetchEmployee ",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_employee, {});

      if (data.status) {
        return data?.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

export const fetchCountries = createAsyncThunk(
  "commonModule/fetchCountries ",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_countries, {});
      if (data?.status) {
        return data?.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

// export const fetchDocumentTypes = createAsyncThunk(
//   "commonModule/fetchDocumentTypes ",
//   async (_, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.get(API_ENDPOINTS?.get_document_types, {});
//       if (data?.status) {
//         return data?.data;
//       }
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to fetch permissions"
//       );
//     }
//   }
// );


export const fetchDocumentTypes = createAsyncThunk(
  "commonModule/fetchDocumentTypes",
  async (params = {}, { rejectWithValue }) => {
    const { type, project_id } = params;

    try {
      const queryParams = new URLSearchParams();

      // Append parameters only if they are provided
      if (type) queryParams.append("type", type);
      if (project_id) queryParams.append("project_id", project_id);

      // Construct the API URL with the optional query string
      const url = `${API_ENDPOINTS?.get_document_types}${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;

      const { data } = await axios.get(url);

      if (data?.status) {
        return data?.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch document types"
      );
    }
  }
);




export const fetchProjectLists = createAsyncThunk(
  "commonModule/fetchProjectLists ",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_project_list, {});
      if (data?.status) {
        return data?.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);



export const fetchSubcon = createAsyncThunk(
  "commonModule/fetchSubcon ",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_subcontractors, {});
      if (data?.status) {
        return data?.data?.docs;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch subcons"
      );
    }
  }
);
export const fetchVendor = createAsyncThunk(
  "commonModule/fetchVendor ",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_ENDPOINTS?.get_vendors, {});
      if (data?.status) {
        return data?.data?.docs;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch subcons"
      );
    }
  }
);






